import useApiClient from './api-client'
import type { EatigoCurrencyCurrencyData } from '@/types/api'
import { getCacheKey, withCache } from './api-store'

export const getCurrency = async () => {
  const api = useApiClient<{ list?: EatigoCurrencyCurrencyData[] }>()
  const apiCaller = () => api(`/currency`)

  return withCache(apiCaller, {
    cacheKey: getCacheKey('currency', {}, false),
    cacheTime: 12 * 60 * 60 * 1000, // cache 12 hours
  })
}
